export default __webpack_public_path__ + "static/media/image15.e9a942a9.png";